import React from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { useSideBar } from "./context/SideBarContext";
import { useTheme } from "./context/ThemeContext";
import { APP_VERSION } from "../utils/constant";
import { Toaster } from 'react-hot-toast'
import { TOAST_OPTIONS } from "./user-pages/ui-helper";
import { ROUTES } from "../utils/key_helper";
const App = () => {
  console.log("APP VERSION", APP_VERSION);

  const location = useLocation(); // Replace withRouter with useLocation
  const { toggleTheme, isDarkTheme } = useTheme();

  const { isSideBarOpen } = useSideBar();
  const restrictedPaths = [ROUTES.LOGIN, ROUTES.NOT_FOUND];
  const currentPath = window.location.pathname.toLowerCase();
  const renderSidebarAndNavbar = !restrictedPaths.some((path) => currentPath.includes(path));
  return (
    <div className="container-scroller">
      <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
      {renderSidebarAndNavbar && <Sidebar />}
      <div className="container-fluid page-body-wrapper">
        {renderSidebarAndNavbar && <Navbar />}
        <div className="main-panel">
          <div className={`content-wrapper ${isSideBarOpen ? "content-wrapper-margin" : "content-wrapper-margin2"} ${isDarkTheme && "content-bg"}`} >
            <AppRoutes />
          </div>
        </div>
      </div>
    </div>
  );
};

export default (App); // Removed withRouter
